 // Export
 const _modal = require("./_modal");
 module.exports =
 {
    createPopup: 
    {

        holding_interval: null,

        modals: 
        {
            "social-main": 
            {
                display: 'flex', // display type
                colour: '#EBF8FD', // background colour
                height: '0.77790178571',  // percentage of screen height to set height
                maxHeight: "568px",
                maxWidth: "calc(100vw - 40px)",
                invertCross: true, // invert the colours of the modal close cross
                center: true,
            }, 
            "social-error": 
            {
                display: 'flex', 
                colour: '#EBF8FD',
                height: '0.77790178571',
                maxHeight: "568px",
                width: "380px",
                invertCross: true,
                center: true,
            },
            "social-denied":
            {
                display: 'flex', 
                colour: '#2B8CC6',
                height: '0.56473214285',
                width: "380px",
                center: true,
            },
            "social-success":
            {
                display: 'flex',
                colour: '#2B8CC6',
                height: '0.56473214285',
                width: "380px",
                center: true,
            },
            "social-holding": 
            {
                display: 'flex', 
                colour: '#EBF8FD',
                px_height: '363px',
                width: "380px",
                noCross: true,
                disableClose: true,
                center: true,
            },
        },
        selected_modal: "",
        
        _init: function ()
        {
            if($('body').hasClass('waiting-for-modal'))
            {
                return
            }

            _modal.setupModals(
                $('#start_modal')?.val() ?? 'main',
                this.modals,
                () => {
                    if($('#social_tariff_post_code') && $('#account-postcode')){
                        $('#social_tariff_post_code').val($('#account-postcode').val())
                    }
        
                    if($('#start_modal')?.val() != ''){
                        if($('#start_modal')?.val() == 'social-holding'){
                            this.holding_interval = setInterval(() => {
                                this.checkHoldingStatus()
                            }, 1000)
                        }
                        
                    }
                }
            )

            this.setupChangeListeners()
            this.calendar()
            this.submitCheck()
            this.checkDetails()
            this.continueButton()
        },
        modalResize: function () {
            if(this.modals[this.selected_modal].height){
                $(`#social-tariff-modal-${this.selected_modal}`)?.css("height", this.modals[this.selected_modal].height * Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0))
            }
            if(this.modals[this.selected_modal].px_height){
                $(`#social-tariff-modal-${this.selected_modal}`)?.css("height", this.modals[this.selected_modal].px_height)
            }
        },
        
        checkDetails: function (){
            let this_class = this
            $('#social-tariff-modal-check-again').on("click", function () {
                if(this_class.holding_interval){
                    clearInterval(this_class.holding_interval)
                }
                $('#start_modal').val("social-main")
                _modal.showModal("social-main")
            })
        },

        validateFields: function(){
            let should_return_false = false

            if(!$('#social_tariff_consent').is(":checked") ){
                let consent_label = $("label[for='social_tariff_consent']")
                consent_label.css("color", "red")
                consent_label[0].scrollIntoView({behavior: "smooth"})
                should_return_false = true
            }

            if($('#social_tariff_post_code').val().length == 0){
                let post_code_label = $("label[for='social_tariff_post_code']")
                post_code_label.css("color", "red")
                post_code_label[0].scrollIntoView({behavior: "smooth"})
                should_return_false = true
            }
            

            if($('#social_tariff_year').find(":selected").val() < 1907 || $('#social_tariff_month').find(":selected").val() < 1 || $('#social_tariff_day').find(":selected").val() < 1){
                let date_label = $("label[for='social-tariff-date']")
                date_label.css("color", "red")
                date_label[0].scrollIntoView({behavior: "smooth"})
                should_return_false = true
            }

            if($('#social_tariff_surname').val().length == 0){
                let last_name_label = $("label[for='social_tariff_surname']")
                last_name_label.css("color", "red")
                last_name_label[0].scrollIntoView({behavior: "smooth"})
                should_return_false = true
            }

            if($('#social_tariff_first_name').val().length == 0){
                let first_name_label = $("label[for='social_tariff_first_name']")
                first_name_label.css("color", "red")
                first_name_label[0].scrollIntoView({behavior: "smooth"})
                should_return_false = true
            }
           
            

            
            return !should_return_false
        },
        submitCheck: function(){
            //validate fields
            let this_class = this

            $('#social-tariff-modal-check').on("click", function(e){

                if(!this_class.validateFields()){
                    return;
                }

                let params = {
                    dateOfBirthYear: $('#social_tariff_year').find(":selected").val(),
                    dateOfBirthMonth: $('#social_tariff_month').find(":selected").val(),
                    dateOfBirthDay: $('#social_tariff_day').find(":selected").val(),
                    existing: $("#social_tariff_existing_plan").length ? true : false,
                    postCode: $('#social_tariff_post_code').val(),
                }
                try{
                    fetch('/social-tariff/check-eligibility/', {method: 'POST', body: $.param(params), headers: {"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"}})
                    .then(response => {
                        _modal.showModal('social-holding')
                        this_class.holding_interval = setInterval(() => {
                            this_class.checkHoldingStatus()
                        }, 1000)
                    })
                }
                catch(err){
                    
                }
            })

            
            
        },
        checkHoldingStatus: function(){
            let this_class = this
            fetch('/social-tariff/check-eligibility/', {method: 'GET'})
                    .then(response => 
                        response.json()
                    )
                    .then(response => {

                        $('.social-tariff-holding-status').text(response.text)
                        if(this_class.selected_modal != 'social-' + response.modal){
                            _modal.showModal('social-' + response.modal)
                        }
                    })
        },
        


        continueButton: function(){
            if($('social-tariff-modal-sign-up-now') && $('#verify-details')){
                $('#social-tariff-modal-sign-up-now').on("click", () => {
                    $('#verify-details').trigger("submit")
                })
            }
        },

        setupChangeListeners: function (){

            $('#social_tariff_consent').on("change", () => {
                let consent_label = $("label[for='social_tariff_consent']")
                consent_label.css("color", "")
            })
            $('#social_tariff_post_code').on("change", () => {
                let post_code_label = $("label[for='social_tariff_post_code']")
                post_code_label.css("color", "")
            })
                
            $('#social_tariff_year').on("change", () => {
                let date_label = $("label[for='social-tariff-date']")
                date_label.css("color", "")
            })
            $('#social_tariff_month').on("change", () => {
                let date_label = $("label[for='social-tariff-date']")
                date_label.css("color", "")
            })
            $('#social_tariff_day').on("change", () => {
                let date_label = $("label[for='social-tariff-date']")
                date_label.css("color", "")
            })

        },
        dayCorrection: function (){
            let days_this_month = new Date($("#social_tariff_year").val() ?? 2004, $("#social_tariff_month").val(), 0).getDate() // use 2004 as it was a leap year

            if($("#social_tariff_day").val() > days_this_month){// day is now outside the range of the month
                $("#social_tariff_day")[0].selectedIndex = 0
                $("#social_tariff_day").val(0)
            }

            $("#social_tariff_day option").each(function() {
                $(this).attr("disabled", $(this).val() > days_this_month);
            })
        },
        calendar: function(){
            //let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

            let prev_day = $("#social_tariff_day").data("value")
            let prev_month = $("#social_tariff_month").data("value")
            let prev_year = $("#social_tariff_year").data("value")

            for(let i = 1; i <= 31; i++){
                $("#social_tariff_day").append("<option value='" + i + "'" + (prev_day == i ? " selected" : "")  + ">" + i.toString().padStart(2, '0') + "</option>")
            }
            for(let i = 1; i <= 12; i++){
                $("#social_tariff_month").append("<option value='" + i + "'" + (prev_month == i ? " selected" : "") + ">" + i.toString().padStart(2, '0') + "</option>")
            }
            let end = new Date().getFullYear() - 18
            let start = 1907
            for(let i = end; i >= start; i--){
                $("#social_tariff_year").append("<option value='" + i + "'" + (prev_year == i ? " selected" : "") + ">" + i + "</option>")
            }

            $("#social_tariff_month").on("change", () => {
                this.dayCorrection()
            })
            $("#social_tariff_year").on("change", () => {
                this.dayCorrection()
            })
        }
    },
    

 }